const LAB_ID = 13;
const EXERCISE_PATH = "/Lab12/Exercise";

const EXERCISE_SELECTION_DEFAULT = "default selection";

const EXERCISE_STATES = {
  EXERCISE_SELECTION_DEFAULT,
};

export { LAB_ID, EXERCISE_PATH, EXERCISE_STATES };
